import { useSelector } from 'react-redux';

const useGetOrderDetailsId = () => {
    return useSelector((state) => state.orderDetailsId.order_details_id);
};

export default useGetOrderDetailsId;